"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./Layout.scss");
var React = require("react");
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.bindAll();
        return _this;
    }
    Layout.prototype.bindAll = function () {
        this.onClick = this.onClick.bind(this);
    };
    Layout.prototype.render = function () {
        var _a = this.props, testId = _a.testId, row = _a.row, col = _a.col, events = _a.events, colOptions = _a.colOptions, rowOptions = _a.rowOptions, layoutOptions = _a.layoutOptions;
        var classes = row ? this.rowClasses(rowOptions) :
            (col ? this.colClasses(colOptions) :
                this.layoutClasses(layoutOptions));
        var offsetClass = this.offsetClass(colOptions);
        var customOptions = (colOptions && colOptions.customOptions ?
            colOptions.customOptions : rowOptions && rowOptions.customOptions ?
            rowOptions.customOptions : layoutOptions && layoutOptions.customOptions ?
            layoutOptions.customOptions : {});
        return (React.createElement(React.Fragment, null,
            col && colOptions && colOptions.offset &&
                React.createElement("div", { className: offsetClass.join(' ') }),
            React.createElement("div", __assign({ "data-test-id": testId, className: classes.join(' ') }, customOptions, { onClick: events && events.onClick ? this.onClick : undefined }), this.props.children)));
    };
    Layout.prototype.layoutClasses = function (options) {
        var classnames = [];
        if (options && options.fullWidth) {
            classnames.push('full-width-container');
        }
        else if (options && options.maxWidth) {
            classnames.push('max-width-container');
        }
        else {
            classnames.push('container');
        }
        if (options && options.breathe) {
            classnames.push('breathe');
        }
        if (options && options.className) {
            classnames.push(options.className);
        }
        return classnames;
    };
    Layout.prototype.colClasses = function (options) {
        var classnames = [];
        if (options && options.size) {
            classnames.push(["grid-col-" + options.size]);
        }
        if (options && options.sizeSM) {
            classnames.push(["grid-col-" + options.sizeSM + "-sm"]);
        }
        if (options && options.sizeMD) {
            classnames.push(["grid-col-" + options.sizeMD + "-md"]);
        }
        if (options && options.alignSelf) {
            classnames.push(["flex-self-" + options.alignSelf]);
        }
        if (options && options.alighItems) {
            classnames.push(["flex-items-" + options.alighItems]);
        }
        if (options && options.justifyContent) {
            classnames.push(["justify-" + options.justifyContent]);
        }
        if (options && options.className) {
            classnames.push(options.className);
        }
        return classnames;
    };
    Layout.prototype.offsetClass = function (options) {
        var offsetclass = [];
        if (options && options.offset) {
            offsetclass.push(["offset" + options.offset]);
        }
        if (options && options.offsetSM) {
            offsetclass.push(["offset" + options.offsetSM + "-sm"]);
        }
        if (options && options.offsetMD) {
            offsetclass.push(["offset" + options.offsetMD + "-md"]);
        }
        return offsetclass;
    };
    Layout.prototype.rowClasses = function (options) {
        var classnames = [];
        if (options && options.noWrap) {
            classnames.push('row-nowrap');
        }
        else if (options && options.forceWrap) {
            classnames.push('row', 'flex-wrap');
        }
        else {
            classnames.push('row');
        }
        if (options && options.className) {
            classnames.push(options.className);
        }
        if (options && options.alignItems) {
            classnames.push([("flex-items-" + (options.alignItems
                    .charAt(0).toUpperCase() + options.alignItems.slice(1))).toLowerCase()]);
        }
        if (options && options.justifyContent) {
            classnames.push(["justify-" + options.justifyContent]);
        }
        if (options && options.alignSelf) {
            classnames.push([("flex-self-" + (options.alignSelf
                    .charAt(0).toUpperCase() + options.alignSelf.slice(1))).toLowerCase()]);
        }
        if (options && options.noPad) {
            classnames.push('nopad');
        }
        return classnames;
    };
    Layout.prototype.onClick = function () {
        if (this.props.events && this.props.events.onClick) {
            return this.props.events.onClick();
        }
    };
    return Layout;
}(React.Component));
exports.default = Layout;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/Layout/Layout.js
// module id = 1847
// module chunks = 8